import { Link } from 'react-router-dom';
import { articles } from '@/mocks/site';

export default function LatestArticles() {
  const latest = articles.filter((a) => !a.isFeatured).slice(0, 6);

  return (
    <section id="latest" className="bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-900">
            最新爆料
          </h2>
          <span className="w-12 h-0.5 bg-primary-500 flex-1 ml-4 hidden sm:block"></span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 黑料吃瓜网`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-secondary-500 text-background-50 rounded-full whitespace-nowrap">
                    {article.tags[0]}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-bold font-heading text-foreground-900 text-sm md:text-base leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm mt-2 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/70">
                  <div className="flex items-center gap-3 text-foreground-400 text-xs">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">
                    {article.author}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/wanghong-tafang"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-foreground-700 bg-background-50 border border-background-200/70 rounded-full hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}